import DefaultList from "@Common/DefaultList";

import { useNavigationHandler } from "@hook";
import { getStatusTag, handleCopyBuffer } from "@utils";
import { inject, observer } from "mobx-react";

import moment from "moment";
import { Tag } from "primereact/tag";

const TestOffersList = inject("mainStore")(
    observer(({ mainStore }) => {
        const navigation = useNavigationHandler();

        const handleRowClick = (e) => {
            navigation(e.originalEvent, `/test-offer/${e.data._id}`);
        };

        return (
            <DefaultList
                dataKey={"abtset_offer"}
                apiUrl="/abtest/aboffers"
                keysToGet={["_id", "title", "active", "archived", "draft", "dateStart", "dateEnd"]}
                titleName="АБ тесты / Офферы"
                titleAddButton="тест"
                keyFilterSearch="title"
                handleRowClick={handleRowClick}
                checkbox={false}
                columns={[
                    {
                        field: "_id",
                        header: "Id",
                        sortable: false,
                        style: { width: "5%" },
                        type: "text",
                        body: (item) => (
                            <div className="id__copy cursor-pointer" onClick={(e) => handleCopyBuffer(e, item, "_id", (val) => mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: `Скопировано`, detail: val }))}>
                                <span className=" text">ID</span>
                                <i className="pi pi-clone"></i>
                            </div>
                        ),
                    },
                    {
                        field: "title",
                        body: (item) => <span className="list__name">{item.title}</span>,
                        header: "Название",
                        sortable: true,
                        style: { maxWidth: "350px", overflow: "hidden" },
                        type: "text",
                    },

                    { field: "dateStart", body: (item) => <span>{moment(item.dateStart).format("DD.MM.YY")}</span>, header: "Дата старта", sortable: true, style: { width: "5%" }, type: "date" },
                    { field: "dateEnd", body: (item) => <span>{moment(item.dateEnd).format("DD.MM.YY")}</span>, header: "Дата завершения", sortable: true, style: { width: "5%" }, type: "date" },
                    {
                        field: "active",
                        header: "Статус",
                        sortable: false,
                        style: { width: "1%" },
                        type: "text",
                        body: (item) => {
                            const tag = getStatusTag(item);
                            return <Tag severity={tag.type} icon={tag.icon} />;
                        },
                    },
                ]}
            />
        );
    }),
);

export default TestOffersList;
